const PIXEL_WIDTH_RE = /^(\d+(?:\.\d+)?)px$/i;

const parsePixelWidth = (value: string) => {
  const match = value.trim().match(PIXEL_WIDTH_RE);

  if (!match) {
    return null;
  }

  const numericWidth = Number(match[1]);

  if (!Number.isFinite(numericWidth) || numericWidth <= 0) {
    return null;
  }

  const roundedWidth = Math.round(numericWidth);

  return {
    cssWidth: `${roundedWidth}px`,
    attrWidth: String(roundedWidth),
  };
};

export const normalizeEditorImageHtml = (html: string) => {
  if (!html || typeof DOMParser === "undefined") {
    return html;
  }

  const parsedDocument = new DOMParser().parseFromString(html, "text/html");
  let hasChanges = false;

  parsedDocument.querySelectorAll("figure.image").forEach((figure) => {
    const figureElement = figure as HTMLElement;

    if (figureElement.style.margin !== "0px") {
      figureElement.style.margin = "0";
      hasChanges = true;
    }

    const figureWidth = figureElement.style?.width?.trim();

    if (!figureWidth) {
      return;
    }

    const normalizedWidth = parsePixelWidth(figureWidth);

    if (!normalizedWidth) {
      return;
    }

    const image = figure.querySelector("img") as HTMLImageElement | null;

    if (!image) {
      return;
    }

    if (image.getAttribute("width") !== normalizedWidth.attrWidth) {
      image.setAttribute("width", normalizedWidth.attrWidth);
      hasChanges = true;
    }

    if (image.style.width !== normalizedWidth.cssWidth) {
      image.style.width = normalizedWidth.cssWidth;
      hasChanges = true;
    }

    if (image.style.height !== "auto") {
      image.style.height = "auto";
      hasChanges = true;
    }

    if (image.hasAttribute("height")) {
      image.removeAttribute("height");
      hasChanges = true;
    }
  });

  return hasChanges ? parsedDocument.body.innerHTML : html;
};
